import React, { useContext } from "react";
import { Wrapper, InputWrapper, Prefix, Label } from "./styled.js";
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { AppContext } from "hocs/withAppContext";


export const CostInput = ({ label, placeholder, required,
                            value, onChange, disabled}) => {
    const { currencySymbol } = useContext(AppContext);
    return <Wrapper>
        {label && <Label required={required}>{label}</Label>}
        <InputWrapper>
            <Prefix disabled={disabled}>{currencySymbol}</Prefix>
            <input
                min="0"
                type="number"
                placeholder={placeholder}
                required={required}
                value={value}
                onChange={e => {
                    if (!onChange) {
                        return;
                    }
                    onChange(parseFloat(e.target.value));
                }}
                disabled={disabled}
            />
        </InputWrapper>
    </Wrapper>
};

export default CostInput;
